function visibleCards(config, { helpCenterEnabled }) {
    return ((config && config.cards) || []).filter((c) => c && c.enabled !== false && (c.type !== "articles" || helpCenterEnabled));
}
function visibleTabs(config, { helpCenterEnabled }) {
    const tabs = (config && config.tabs) || {};
    const out = [];
    if (tabs.home !== false) out.push("home");
    out.push("messages");
    if (tabs.help !== false && helpCenterEnabled) out.push("help");
    return out;
}
module.exports = { visibleCards, visibleTabs };



// WEBPACK FOOTER //
// ./src/utils/shell/visibleCards.js